var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_575_43902)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.8161 26.4793V17.5835H11.3963V14.3806H13.8161V11.6449C13.8161 9.49517 15.2455 7.521 18.5391 7.521C19.8727 7.521 20.8588 7.64527 20.8588 7.64527L20.7811 10.6362C20.7811 10.6362 19.7754 10.6267 18.678 10.6267C17.4903 10.6267 17.3 11.1588 17.3 12.0419V14.3806H20.8755L20.7199 17.5835H17.3V26.4793H13.8161Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_575_43902"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.47917,
    height: 18.9583,
    fill: "white",
    transform: "translate(11.3974 7.521)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon2.6ef2238ce74a9b7204967fc7bc5eb099.svg";
export { ForwardRef as ReactComponent };